import { Fragment } from "react";

import { css } from "@compiled/react";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";

export type FreeTeam24Props = {
    formattedZeroPrice: string;
    fontSize: string;
    planName: string;
};

const freeContainerStyles = css(centerJustifiedStyling);

export const FreeTeam24 = ({
    planName,
    formattedZeroPrice,
    fontSize
}: FreeTeam24Props) => {
    return (
        <Fragment>
            <PriceDisplay
                planName={planName}
                formattedPrice={formattedZeroPrice}
                fontSize={fontSize}
            />
            <div css={freeContainerStyles} />
        </Fragment>
    );
};
